import React, { useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import axios from "axios";

// Logo URL from Cloudinary
const logo = "https://res.cloudinary.com/dihtuaq6d/image/upload/v1760187144/xrk9fhrhbahbkvjzy1db.jpg";

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    password_confirmation: ''
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const persistLoginAndRedirect = (data) => {
    const extra = data?.extra || {};
    const user = data?.result || {};

    const expiresInSeconds = Number(data?.expiresIn || data?.expires_in || 24 * 60 * 60);
    const expireDate = new Date(new Date().getTime() + expiresInSeconds * 1000);

    const tokenDetails = {
      token: extra.authToken || '',
      tokenType: extra.tokenType || 'Bearer',
      email: user.email || data?.email || formData.email,
      user,
      expiresIn: expiresInSeconds,
      expireDate,
    };

    localStorage.setItem('userDetails', JSON.stringify(tokenDetails));

    let dashboardRoute = '/admin/dashboard';
    if (extra && extra.isAdmin === true) {
      dashboardRoute = '/admin/dashboard';
    } else if (user && user.user_type_id === 2) {
      dashboardRoute = '/consultant/dashboard';
    } else if (user && user.user_type_id === 1 && (!extra || extra.isAdmin === false)) {
      dashboardRoute = '/entreprise/dashboard';
    }

    navigate(dashboardRoute);
  };

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    
    // Validation
    if (!formData.email) {
      setError('Veuillez entrer votre adresse email');
      return;
    }
    if (!formData.password) {
      setError('Veuillez entrer un nouveau mot de passe');
      return;
    }
    if (formData.password.length < 8) {
      setError('Le mot de passe doit contenir au moins 8 caractères');
      return;
    }
    if (formData.password !== formData.password_confirmation) {
      setError('Les mots de passe ne correspondent pas');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await axios.post('https://update.senoffre.com/api/auth/password/reset', {
        email: formData.email,
        token: token,
        password: formData.password,
        password_confirmation: formData.password_confirmation
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-AppApiToken': 'senoffre_api_token_2024_secure_key_xyz123'
        }
      });

      if (response.data?.success) {
        try {
          const loginResponse = await axios.post('https://update.senoffre.com/api/auth/login', {
            email: formData.email,
            password: formData.password,
          }, {
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'X-AppApiToken': 'senoffre_api_token_2024_secure_key_xyz123'
            }
          });

          persistLoginAndRedirect(loginResponse.data);
          return;
        } catch (loginErr) {
          setSuccess(true);
          setTimeout(() => {
            navigate('/login');
          }, 2000);
        }
      } else {
        setError(response.data?.message || 'Une erreur est survenue');
      }
    } catch (err) {
      console.error('Reset password error:', err);
      const message = err?.response?.data?.message || 'Ce lien de réinitialisation est invalide ou a expiré.';
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="authincation h-100 p-meddle">
      <div className="container h-100">
        <div className="row justify-content-center h-100 align-items-center">
          <div className="col-md-6">
            <div className="authincation-content">
              <div className="row no-gutters">
                <div className="col-xl-12">
                  <div className="auth-form">
                    <div className="text-center mb-3">
                      <Link to="/login">
                        <img src={logo} alt="SenOffre" style={{ maxWidth: '150px' }} />
                      </Link>
                    </div>
                    <h4 className="text-center mb-4">Réinitialiser le mot de passe</h4>

                    {success ? (
                      <div className="text-center">
                        <div className="alert alert-success">
                          <i className="fa fa-check-circle me-2"></i>
                          Votre mot de passe a été réinitialisé avec succès !
                        </div>
                        <p className="text-muted mt-3">
                          Vous allez être redirigé vers la page de connexion...
                        </p>
                        <Link to="/login" className="btn btn-primary mt-3">
                          Se connecter maintenant
                        </Link>
                      </div>
                    ) : (
                      <form onSubmit={onSubmit}>
                        {error && (
                          <div className="alert alert-danger">
                            <i className="fa fa-exclamation-triangle me-2"></i>
                            {error}
                          </div>
                        )}

                        <div className="form-group mb-3">
                          <label className="mb-1">
                            <strong>Email</strong>
                          </label>
                          <input
                            type="email"
                            className="form-control"
                            placeholder="Entrez votre adresse email"
                            value={formData.email}
                            onChange={(e) => handleChange('email', e.target.value)}
                            required
                          />
                        </div>

                        <div className="form-group mb-3">
                          <label className="mb-1">
                            <strong>Nouveau mot de passe</strong>
                          </label>
                          <div className="input-group">
                            <input
                              type={showPassword ? "text" : "password"}
                              className="form-control"
                              placeholder="Entrez votre nouveau mot de passe"
                              value={formData.password}
                              onChange={(e) => handleChange('password', e.target.value)}
                              required
                              minLength={8}
                            />
                            <button
                              type="button"
                              className="btn btn-outline-secondary"
                              onClick={() => setShowPassword(!showPassword)}
                            >
                              <i className={`fa ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                            </button>
                          </div>
                          <small className="text-muted">Minimum 8 caractères</small>
                        </div>

                        <div className="form-group mb-4">
                          <label className="mb-1">
                            <strong>Confirmer le mot de passe</strong>
                          </label>
                          <input
                            type={showPassword ? "text" : "password"}
                            className="form-control"
                            placeholder="Confirmez votre nouveau mot de passe"
                            value={formData.password_confirmation}
                            onChange={(e) => handleChange('password_confirmation', e.target.value)}
                            required
                          />
                        </div>

                        <div className="text-center">
                          <button
                            type="submit"
                            className="btn btn-primary btn-block"
                            disabled={loading}
                            style={{ 
                              background: 'linear-gradient(135deg, #145650 0%, #0d3d39 100%)',
                              border: 'none'
                            }}
                          >
                            {loading ? (
                              <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Réinitialisation en cours...
                              </>
                            ) : (
                              'Réinitialiser le mot de passe'
                            )}
                          </button>
                        </div>

                        <div className="new-account mt-4 text-center">
                          <p>
                            <Link className="text-primary" to="/login">
                              <i className="fa fa-arrow-left me-2"></i>
                              Retour à la connexion
                            </Link>
                          </p>
                        </div>
                      </form>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
